export default { sha: 'fc49911559bd64c6b588d8da3c9d9cbe1d94b8bf', buildNumber: 'undefined' }
